import React from 'react';
import { Box, Typography } from '@mui/material';
import ChatAvatarComponent from '../../chat/ChatAvatarComponent';
import { NOT_REQUIRED } from '../../../../../utils/requirementsScore';

const Leaderboard: React.FC<{ data: any[]; loader?: boolean }> = ({ data = [], loader }) => {
  const leaderboardData = [...data]
    .sort((a, b) => (b.goalProgress ?? 0) - (a.goalProgress ?? 0))
    .map((item, index) => ({
      ...item,
      rank: index + 1
    }));

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'inline-flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 1.25,
        fontFamily: 'Inter !important'
      }}
    >
      <Typography
        sx={{
          color: 'var(--Text-text-primary, #FDFDFD)',
          fontSize: 14,
          fontWeight: 700,
          lineHeight: '19.88px'
        }}
      >
        Program Leaderboard:
      </Typography>
      <Box
        sx={{
          alignSelf: 'stretch',
          // height: 198,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          gap: 0.5,
          // background: '#0F0F0F'
        }}
      >
        <Box
          sx={{
            alignSelf: 'stretch',
            pt: 0.75,
            pb: 0.75,
            pr: 1.25,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 2.5
          }}
        >
          <Box sx={{ flex: '1 1 0', display: 'inline-flex', alignItems: 'center', gap: 1 }}>
            <Typography
              sx={{
                width: 24,
                height: 22,
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'var(--Text-text-secondary, #B6B6B6)',
                fontSize: 18,
                fontWeight: 700,
                lineHeight: '21.6px'
              }}
            >
              #
            </Typography>
            <Typography
              sx={{
                color: 'var(--Text-text-primary, #FDFDFD)',
                fontSize: 12,
                fontWeight: 700,
                lineHeight: '14.4px'
              }}
            >
              Name
            </Typography>
          </Box>
          <Box sx={{ width: 84, display: 'inline-flex', justifyContent: 'center' }}>
            <Typography
              sx={{
                color: 'var(--Text-text-secondary, #B6B6B6)',
                fontSize: 10,
                fontWeight: 400,
                lineHeight: '13px'
              }}
            >
              Program Progress
            </Typography>
          </Box>
          <Box sx={{ width: 94, display: 'inline-flex', justifyContent: 'center' }}>
            <Typography
              sx={{
                color: 'var(--Text-text-secondary, #B6B6B6)',
                fontSize: 10,
                fontWeight: 400,
                lineHeight: '13px'
              }}
            >
              Running Quiz Score
            </Typography>
          </Box>
        </Box>
        {leaderboardData.map((item) => (
          <Box
            key={item?.id || item?.displayName}
            sx={{
              alignSelf: 'stretch',
              pt: 0.75,
              pb: 0.75,
              pr: 1.25,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 2.5,
              background: item?.isCurrentUser ? 'var(--Fill-Card-card-highlight, #1C1C1C)' : 'transparent',
              borderRadius: item?.isCurrentUser ? 1 : 0
            }}
          >
            <Box sx={{ flex: '1 1 0', display: 'inline-flex', alignItems: 'center', gap: 1 }}>
              <Typography
                sx={{
                  width: 24,
                  height: 22,
                  textAlign: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: 'var(--Text-text-secondary, #B6B6B6)',
                  fontSize: 18,
                  fontWeight: 700,
                  lineHeight: '21.6px'
                }}
              >
                {item.rank}
              </Typography>
              <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
                <ChatAvatarComponent
                  image={item.headshot}
                  firstLetter={item.displayName?.charAt(0)}
                  width="40px"
                  height="40px"
                  type="noStatus"
                />
                <Typography
                  sx={{
                    color: 'var(--Text-text-primary, #FDFDFD)',
                    fontSize: 12,
                    fontWeight: 700,
                    lineHeight: '14.4px'
                  }}
                >
                  {item.displayName}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ width: 84, display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }}>
              <Typography
                sx={{
                  color: 'var(--Text-text-primary, #FDFDFD)',
                  fontSize: 18,
                  fontWeight: 700,
                  lineHeight: '21.6px'
                }}
              >
                {Math.round(item.goalProgress ?? 0)}
              </Typography>
              <Typography
                sx={{
                  color: 'var(--Text-text-primary, #FDFDFD)',
                  fontSize: 18,
                  fontWeight: 700,
                  lineHeight: '21.6px'
                }}
              >
                %
              </Typography>
            </Box>
            <Box sx={{ width: 94, display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }}>
              <Typography
                sx={{
                  color: 'var(--Text-text-tertiary, #868686)',
                  fontSize: 18,
                  fontWeight: 700,
                  lineHeight: '21.6px'
                }}
              >
                {/* Null: assessed on nothing in this program (DA-5056 R5), a dash rather than 0%. */}
                {item.MCQScore === null ? NOT_REQUIRED : Math.round(item.MCQScore ?? 0)}
              </Typography>
              {item.MCQScore !== null && (
                <Typography
                  sx={{
                    color: 'var(--Text-text-tertiary, #868686)',
                    fontSize: 18,
                    fontWeight: 700,
                    lineHeight: '21.6px'
                  }}
                >
                  %
                </Typography>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Leaderboard;
